import React, { useEffect, useState } from 'react'
import { Typography, Button, TextField, IconButton } from '@mui/material';
import MostrarError from '../../../components/AccionesPartes/MostrarError';
import CancelIcon from '@mui/icons-material/Cancel';

function Noticias() {
    const API_URL = 'https://api.workers.grupotel.com/';

    const [mensajeError, setMensajeError] = useState('');
    const [tipoError, setTipoError] = useState('');
    const [contadorError, setContadorError] = useState(1);
    const [estadoAlert, setEstadoAlert] = React.useState(false);

    const mostrarError = (mensajeError, tipoError) => {
        setMensajeError(mensajeError);
        if (tipoError) {
            setTipoError(tipoError);
        } else {
            setTipoError("error");
        }
        setContadorError(contadorError + 1);
        setEstadoAlert(true);
        const timer2 = setTimeout(() => {
            setEstadoAlert(false);
        }, 3000);
        return () => clearTimeout(timer2);
    };

    const [nuevaNoticia, setNuevaNoticia] = useState({
        asunto: '',
        texto: '',
        foto: null,
        pdf: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNuevaNoticia((prev) => ({ ...prev, [name]: value }));
    };

    const [previewImg, setPreviewImg] = useState(null);
    const handleImagen = (e) => {
        const archivo = e.target.files[0];
        if (archivo) {
            setNuevaNoticia((prev) => ({ ...prev, foto: archivo }));
            setPreviewImg(URL.createObjectURL(archivo));
        }
    };

    const borrarImagen = () => {
        setNuevaNoticia((prev) => ({ ...prev, foto: null }));
        setPreviewImg(null);
    };

    const [previewPdf, setPreviewPdf] = useState(null);
    const selecPdf = (e) => {
        const archivo = e.target.files[0];
        if (archivo) {
            setNuevaNoticia((prev) => ({ ...prev, pdf: archivo }));

            let nombrePdf = "";
            if (archivo.name.length > 29) {
                nombrePdf = archivo.name.substring(0, 29) + "...";
            } else {
                nombrePdf = archivo.name;
            }
            // setPreviewPdf(URL.createObjectURL(archivo));
            setPreviewPdf({
                ruta: URL.createObjectURL(archivo),
                nombre: nombrePdf,
                archivo: archivo
            });
        }
    };

    const borrarPdf = () => {
        setNuevaNoticia((prev) => ({ ...prev, pdf: null }));
        setPreviewPdf(null);
    };

    const crearNoticia = async () => {
        const { asunto, texto, foto, pdf } = nuevaNoticia;

        if (!asunto || !texto) {
            mostrarError("Debes rellenar el asunto y el texto.");
            return;
        }

        const params_str = `asunto="${asunto}"|texto="${texto}"`;
        const fd = new FormData();
        fd.append("f", "noticia.setNoticia");
        fd.append("params", params_str);
        fd.append("token", localStorage.getItem('token'));

        if (foto) {
            fd.append("foto", foto);
        }
        if(pdf){
            fd.append("pdf", pdf);
        }
        try {
            const response = await fetch(`${API_URL}`, {
                method: 'POST',
                body: fd
            });

            const result = await response.json();

            if (result.error && result.error.id !== 0) {
                mostrarError(result.error.msg || "Error desconocido");
            } else {
                mostrarError("Noticia creada correctamente", "success");

                setNuevaNoticia({ asunto: '', texto: '', foto: null, pdf: null });
                setPreviewImg(null);
                setPreviewPdf(null);
            }
        } catch (error) {
            console.error(error);
            mostrarError("Error al conectar con el servidor");
        }
    };

    useEffect(() => {
    }, [])

    return (
        <div className='container'>
            <div>
                <div className='header'>
                    <h1 className='centrar'>Noticias</h1>
                </div>
                <div className='homeContainer'>
                    <div className='homeContainerHeader'>
                        <Typography variant="h5" component="div" className='centrar'>
                            Crear Noticias para los Usuarios
                        </Typography>
                    </div>
                    <div
                        className='divFormNoticia'
                    >
                        <div className='widthAll'>
                            <TextField
                                label="Título"
                                name="asunto"
                                variant="outlined"
                                margin="normal"
                                size="small"
                                className='observaciones'
                                value={nuevaNoticia.asunto}
                                onChange={handleChange}
                            />
                        </div>
                        <div className='widthAll'>
                            <div className='rowFlex'>
                                {/* Contenido - 50% */}
                                <div className='colMitad'>
                                    <TextField
                                        label="Contenido"
                                        name="texto"
                                        variant="outlined"
                                        margin="normal"
                                        multiline
                                        rows={10}
                                        className='nuevoParteText widthAll'
                                        value={nuevaNoticia.texto}
                                        onChange={handleChange}
                                    />
                                </div>
                                {/* Imagen - 50% */}
                                <div className='colMitad centrarTodo'>
                                    <div >
                                        <div>
                                            <label htmlFor="upload-foto" className='nuevoParteBotonAdjuntar'>
                                                <input
                                                    className='ocultar'
                                                    accept=".jpg,.jpeg,.png"
                                                    id="upload-foto"
                                                    type="file"
                                                    onChange={handleImagen}
                                                />
                                                <Button component='span' className='colorGrupo botonImgNoticia botonImgNoticia' variant="contained">
                                                    Adjuntar imagen
                                                </Button>
                                            </label>
                                        </div>
                                        {previewImg && (
                                            <div className='divCentrarImagen botonImgNoticia' >
                                                <IconButton className='iconoBorrarImg' onClick={borrarImagen}>
                                                    <CancelIcon className=' ' />
                                                </IconButton>
                                                <img className="editarPartePreviewImagen" src={previewImg} onClick={() => window.open(previewImg)} />
                                            </div>
                                        )}
                                    </div>
                                    <div >
                                        <div>
                                            <label htmlFor="upload-pdf" className='nuevoParteBotonAdjuntar'>
                                                <input
                                                    className='ocultar'
                                                    accept=".pdf"
                                                    id="upload-pdf"
                                                    type="file"
                                                    onChange={selecPdf}
                                                />
                                                <Button component='span' className='colorGrupo botonImgNoticia botonImgNoticia' variant="contained">
                                                    Adjuntar Pdf
                                                </Button>
                                            </label>
                                        </div>
                                        {previewPdf && (
                                            <div className='divCentrarImagen botonImgNoticia' >
                                                <Button className='nuevoParteNombrePdf' variant="text" onClick={() => window.open(previewPdf.ruta)} >{previewPdf.nombre ? previewPdf.nombre : ''}</Button>
                                                <IconButton className='iconoBorrarImg' onClick={borrarPdf}>
                                                    <CancelIcon className=' ' />
                                                </IconButton>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='justiRight'>
                            <Button
                                className='colorGrupo '
                                variant="contained"
                                onClick={crearNoticia}
                            >
                                Crear Noticia
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <MostrarError mensajeEr={mensajeError} tipoError={tipoError} contadorError={contadorError} estadoAlert={estadoAlert} />
        </div>
    )
}
export default Noticias;